<template>
  <div style="width: 100%">
    <v-container class="px-8 py-5">
      <v-row>
        <v-col>
          <v-row class="body-2 font-weight-light">
            <span>Predmeti</span>
            <v-spacer></v-spacer>
            <span>{{$todayDate()}}</span>
          </v-row>
          <v-row class="py-6">
            <v-col cols="12" sm="4">
              <v-text-field
                  outlined
                  placeholder="Pretraži predmete..."
                  hide-details
                  dense
                  v-model="search"
                  height="44"
                  append-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col v-if="$checkPermission('subjects create')" cols="12" sm="8">
              <div class="d-flex justify-end">
                <v-btn
                    @click="$router.push('predmeti/dodaj')"
                    class="primary text-none elevation-0 px-4">
                  <v-icon left>mdi-plus</v-icon> Dodaj
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-data-table
                :headers="headers"
                :items="subjects"
                :options.sync="options"
                :server-items-length="totalItems"
                style="cursor:pointer;"
            >
              <template v-slot:[`item.id`]="{item}">
                <v-tooltip top v-if="$checkPermission('grade_types create')">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="action-button elevation-0 mr-2"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="gradeTypes(item)">
                      <v-icon
                          color="white"
                          size="16">
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Elementi ocjenjivanja</span>
                </v-tooltip>
                <v-btn
                    v-if="$checkPermission('subjects edit')"
                    class="action-button elevation-0 mr-2"
                    color="primary"
                    @click.stop="$router.push(`predmeti/${item.id}/uređivanje`)"
                ><v-icon
                    color="white"
                    size="16"
                >mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                    v-if="$checkPermission('subjects delete')"
                    class="action-button red darken-2 elevation-0"
                    @click.stop="dialog = true; currentSubjectId = item.id;"
                ><v-icon
                    color="white"
                    size="16"
                >mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-row>

        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-model="dialog"
        width="500"
    >
      <v-card class="pa-6">
        <v-card-title class="pa-0 text-subtitle-1">
          Jeste li sigurni da želite obrisati odabrani predmet?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3 mt-2">
          Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka.
          Jeste li sigurni da želite izbrisati odabrani resurs?
        </v-card-text>
        <v-card-actions class="mt-4">
          <v-row>
            <v-col cols="12" sm="4">
              <v-btn
                  height="44"
                  block
                  class="red white--text elevation-0"
                  @click="deleteSubject()"
              >Izbriši</v-btn>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn
                  outlined
                  block
                  height="44"
                  class="elevation-0"
                  @click="dialog = false"
              >Odustani</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Elementi ocjenjivanja -->
    <v-dialog v-model="gradeTypeDialog" width="500"
              v-if="currentSubject && $checkPermission('grade_types create')">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Elementi ocjenjivanja - {{currentSubject.title}}
        </v-card-title>

        <v-card-text class="text--primary">
          <div v-for="item in currentGradeTypes" :key="item.title + item.id"
              :class="{'selected-cat': selectedParent && selectedParent.id == item.id}">
            <div class="my-2 w-100 d-flex align-center justify-space-between">
              <h4>
                {{item.title}}
              </h4>
              <div>
                <v-btn class="action-button blue darken-2 elevation-0 mr-2"
                       @click.stop="selectParent(item)"><v-icon
                    color="white" size="16">mdi-plus</v-icon>
                </v-btn>
                <v-btn class="action-button red darken-2 elevation-0"
                       @click.stop="deleteGradeType(item.id)"><v-icon
                    color="white"
                    size="16">mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <template v-if="item.children.length > 0">
              <div v-for="subitem in item.children" :key="subitem.title + subitem.id"
                   class="ml-2 my-2 w-100 d-flex align-center justify-space-between">
                <h5>
                  {{subitem.title}}
                </h5>
                <v-btn class="action-button red darken-2 elevation-0"
                       @click.stop="deleteGradeType(subitem.id)"><v-icon
                    color="white"
                    size="12">mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </div>
          <v-divider></v-divider>
          <div v-if="selectedParent"
              class="d-flex align-center mt-5 justify-space-between">
            <h5>
              Odabrano: {{selectedParent.title}}
            </h5>
            <v-icon
                @click="selectParent(null)"
                color="black"
                size="20">
              mdi-close
            </v-icon>
          </div>

          <v-form @submit.prevent="addGradeType">
            <div class="d-flex align-center">
              <v-text-field
                  v-model="newGradeType.title"
                  label="Naziv"
                  required>
              </v-text-field>
              <v-btn class="ml-4" color="primary" type="submit">Dodaj</v-btn>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-pagination
            v-if="length > 1"
            v-model="page"
            class="my-4"
            :length="length"
            :total-visible="5"
            @input="getGradeTypes"
        ></v-pagination>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="gradeTypeDialog = false">
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from '../../services/ApiV2'

export default {
  name: 'Home',
  data: () => ({
    subjects: [],
    search: '',
    currentSubjectId: null,
    currentSubject: null,
    dialog: false,
    options: {},
    totalItems: 0,
    gradeTypeDialog: false,
    newGradeType: {
      title: '',
      parent_id: null,
      school_id: null
    },
    selectedParent: null,
    currentGradeTypes: [],
    page: 1,
    perPage: 15,
    length: 0,
  }),
  computed: {
    headers() {
      return [
        { text: 'Naziv predmeta', value: 'title' },
        { text: 'Akcija', value: 'id', align: 'center'},
      ]
    },
    school: function () {
      return this.$store.getters.getSchool
    }
  },
  created(){
    if(localStorage.getItem('subject-options')){
      this.options = JSON.parse(localStorage.getItem('subject-options'));
      this.search = this.options.search
    }
    // this.getSubjects()
  },
  methods: {
    getSubjects() {
      let params = {
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        sortDesc: this.options.sortDesc,
        sortBy: this.options.sortBy,
        //with: ['gradeTypes'],
        filter: {
          title: '~=' + this.search
        }
      }

      ApiV2.get(`subjects`, {
        params: params
      }).then(response => {
        this.subjects = response.data.data;
        this.totalItems = response.data.total;
      });
    },
    deleteSubject() {
      ApiV2.delete(`subjects/${this.currentSubjectId}`)
          .then((response) => {
            this.dialog = false;
            this.subjects = response.data;
            serverBus.$emit('show-snackbar', true, 'Uspješno se izbrisali predmet.');
          })
          .catch(() => {
            serverBus.$emit('show-snackbar', false);
          });
    },
    async gradeTypes(subject) {
      this.currentSubjectId = subject.id;
      this.currentSubject = subject
      this.gradeTypeDialog = true;
      this.newGradeType.title = '';
      this.newGradeType.parent_id = null;
      this.newGradeType.school_id = this.school.id;
      this.selectedParent = null;
      await this.getGradeTypes()
    },
    async getGradeTypes() {
      let {data} = await ApiV2.get('/subjects/' + this.currentSubject.id + '/gradeTypes', {
        params: {
          page: this.page,
          perPage: this.perPage,
          filter: {
            parent_id: 'n=',
          },
          with: ['children']
        }
      })
      this.currentGradeTypes = data.data;
      this.length = data.last_page;
    },
    async addGradeType() {
      this.newGradeType.subject_id = this.currentSubject.id
      this.newGradeType.school_id = this.school.id
      try {
        await ApiV2.post('/grade_types', this.newGradeType)
        this.newGradeType = {}
        await this.getGradeTypes()
      } catch (e) {
        let msg = e.response?.data?.message || 'Nešto je pošlo krivo'
        serverBus.$emit('show-snackbar', false, msg)
      }
    },
    async deleteGradeType(gradeTypeId) {
      try {
        let response = await ApiV2.delete(`/grade_types/${gradeTypeId}`)
        if (response.status === 204) {
          await this.getGradeTypes()
        }
      } catch (e) {
        let msg = e.response.data.message || 'Nešto je pošlo krivo';
        serverBus.$emit('show-snackbar', false, msg);
      }
    },
    selectParent(parent) {
      this.selectedParent = parent
      this.newGradeType.parent_id = parent.id
    }
  },
  watch: {
    options: {
      handler() {
        this.options.search = this.search;
        localStorage.setItem('subject-options', JSON.stringify(this.options));
        this.getSubjects()
      },
      deep: true
    },
    search: {
      handler() {
        this.options.page = 1
        this.options.search = this.search;


        localStorage.setItem('subject-options', JSON.stringify(this.options));
        this.getSubjects()
      },
      deep: true
    },
    gradeTypeDialog(newVal) {
      if (!newVal) {
        this.currentGradeTypes = []
        this.currentSubject = null
        this.page = 1;
        this.length = 0;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.action-button {
  height: 32px !important;
  min-width: 32px !important;
  width: 32px;
}

.selected-cat {
  color: #004379 !important;
}
</style>
